import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto text-center">
        <div className="relative rounded-2xl overflow-hidden mb-10 md:mb-14 mx-auto max-w-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20illustration%20scene%2C%20dreamy%20reading%20atmosphere%2C%20warm%20coral%20and%20golden%20light%2C%20magical%20books%20floating%2C%20cozy%20aesthetic%2C%20soft%20film%20grain%20texture%2C%20cinematic%20composition%2C%20warm%20ambient%20lighting&width=1200&height=500&seq=home-cta-image&orientation=landscape"
            alt="开启韩漫之旅"
            className="w-full h-[280px] md:h-[360px] object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-snug mb-2">
          {t('home.cta.title')}{' '}
          <span className="text-primary-500 italic">{t('home.cta.titleHighlight')}</span>
        </h2>
        <p className="text-base text-foreground-500 mb-8 max-w-lg mx-auto">
          {t('home.cta.subtitle')}
        </p>
        <Link
          to="/category/all"
          className="inline-block whitespace-nowrap px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
        >
          {t('home.cta.btn')}
        </Link>
      </div>
    </section>
  );
}